import React from 'react';
import { Box, Heading, Text, VStack, Icon, Button, Center } from '@chakra-ui/react';
import { AiOutlineLock } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';

const AcessoNegado = () => {
    const navigate = useNavigate();

    return (
        <Center minH="70vh" px={4}>
            <VStack
                spacing={6}
                p={8}
                bg="surface"
                border="1px solid"
                borderColor="borderPrimary"
                borderRadius="2xl"
                maxW="450px"
                textAlign="center"
                boxShadow="xl"
            >
                <Box
                    p={4}
                    bg="rgba(254, 178, 178, 0.15)"
                    borderRadius="full"
                    color="red.400"
                    display="inline-flex"
                >
                    <Icon as={AiOutlineLock} boxSize="40px" />
                </Box>
                <VStack spacing={2}>
                    <Heading size="md" color="textPrimary" fontWeight="900" letterSpacing="1px">
                        ACESSO RESTRITO
                    </Heading>
                    <Text color="textSecondary" fontSize="sm">
                        Você não possui permissão para visualizar esta página. Caso ache que isso seja um erro, entre em contato com o administrador do sistema.
                    </Text>
                </VStack>
                <Button
                    size="sm"
                    bg="secondary"
                    color="primary"
                    _hover={{ bg: 'secondaryHover' }}
                    fontWeight="800"
                    onClick={() => navigate('/')}
                >
                    Voltar para o Início
                </Button>
            </VStack>
        </Center>
    );
};

export default AcessoNegado;
